<template>
  <div class="Box">
    <input
      class="checkbox-tools"
      type="radio"
      name="tools"
      :value="lang"
      :id="id"
      v-model="$i18n.locale"
    >
    <label class="for-checkbox-tools" :for="id">
      {{lang}}
    </label>
  </div>
</template>

<script>
export default {
  props: ['lang', 'id']
}
</script>

<style lang="scss">

:root {
  --white: #D4F2D4;
  --light: #1d5820;
  --black: #1d5820;
  --dark-blue: #1d5820;
  --dark-light: #1d5820;
  --red: #1d5820;
  --yellow: #4AC828;
  --grey: #1d5820;
}

.Box {
  /* #Primary
  ================================================== */
  .checkbox:checked ~ .background-color{
    background-color: var(--white);
  }

  [type="checkbox"]:checked,
  [type="checkbox"]:not(:checked),
  [type="radio"]:checked,
  [type="radio"]:not(:checked){
    position: absolute;
    width: 0;
    height: 0;
    visibility: hidden;
  }

  .checkbox:checked + label,
  .checkbox:not(:checked) + label{
    position: relative;
    width: 60px;
    display: inline-block;
    padding: 0;
    margin: 0 auto;
    text-align: center;
    margin: 17px 0;
    margin-top: 100px;
    height: 6px;
    border-radius: 4px;
    background-image: linear-gradient(298deg, var(--red), var(--yellow));
    z-index: 100 !important;
  }

  .checkbox:checked + label:before,
  .checkbox:not(:checked) + label:before {
    position: absolute;
    font-family: 'unicons';
    cursor: pointer;
    top: -17px;
    z-index: 2;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    width: 40px;
    border-radius: 50%;
    -webkit-transition: all 300ms linear;
    transition: all 300ms linear;
  }

  .checkbox:not(:checked) + label:before {
    content: '\eac1';
    left: 0;
    color: var(--grey);
    background-color: var(--dark-light);
    box-shadow: 0 4px 4px rgba(0,0,0,0.15), 0 0 0 1px rgba(26,53,71,0.07);
  }

  .checkbox:checked + label:before {
    content: '\eb8f';
    left: 30px;
    color: var(--yellow);
    background-color: var(--dark-blue);
    box-shadow: 0 4px 4px rgba(26,53,71,0.25), 0 0 0 1px rgba(26,53,71,0.07);
  }

  .checkbox:checked ~ .section .container .row .col-12 p{
    color: var(--dark-blue);
  }

  .checkbox-tools:checked + label,
  .checkbox-tools:not(:checked) + label{
    position: relative;
    display: inline-block;
    padding: 5px;
    width: 60px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    margin: 0 auto;
    margin-left: 5px;
    margin-right: 5px;
    text-align: center;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    text-transform: uppercase;
    color: var(--white);
    -webkit-transition: all 300ms linear;
    transition: all 300ms linear;
  }

  .checkbox-tools:not(:checked) + label{
    background-color: var(--dark-light);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .checkbox-tools:checked + label{
    background-color: transparent;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }

  .checkbox-tools:not(:checked) + label:hover{
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }

  .checkbox-tools:checked + label::before,
  .checkbox-tools:not(:checked) + label::before{
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background-image: linear-gradient(298deg, var(--red), var(--yellow));
    z-index: -1;
  }

  .checkbox-tools:checked + label .uil,
  .checkbox-tools:not(:checked) + label .uil{
    font-size: 24px;
    line-height: 24px;
    display: block;
    padding-bottom: 10px;
  }

  .checkbox:checked ~ .section .container .row .col-12 .checkbox-tools:not(:checked) + label{
    background-color: var(--light);
    color: var(--dark-blue);
    box-shadow: 0 1x 4px 0 rgba(0, 0, 0, 0.05);
  }
}

</style>
